import { default as _91_46_46_46slug_93f6ypb1Tz3kMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/[...slug].vue?macro=true";
import { default as indexXJ4Sw2aKczMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/auth/index.vue?macro=true";
import { default as indexd9GaP2GMz4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93CkFdoLRH4YMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93ZHtmpDFmrFMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93X9Z6cUoZclMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93iEx4cat3aZMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/news/[slug].vue?macro=true";
import { default as organisationsnCHqR2lgzvMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventslXhmi17eo4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsb3UqkNGT3EMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexQhDp8j3YOHMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index.vue?macro=true";
import { default as dungeonVanF5FOLiqMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsm1C1e1NkDnMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexpbcFHz5gINMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index.vue?macro=true";
import { default as indexMURRWptuzAMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataTO2T3Him6IMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClass6l0f96MADHMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93Xrc2QVbF7vMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexYHlJoNny8cMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDatao925yFGQZ2Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsaRcJokwUmCMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsyk5jVch0jkMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightshviTZO7utEMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93CoLCnKn8ENMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index9sPDoGuuG4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivities8pOR4bwQoJMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataJgxroGGFO4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93Y23UiNixXUMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as index4WYHgrNQ4HMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesunSOMPfRexMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataCyCiYcTSATMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93EIsG3I1UiYMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexU1J2zMNiUUMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDatadAcdLhcKk3Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93MvNuRQkdWvMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexWV2o2ZR97FMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseData9e4xPW1Q2PMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClass9uzeg4DZjRMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedForms2LznHMw0yHMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93IsS3mG5NKsMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexN836pZ7DspMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesVoKS2g5ZgDMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataQVBhlTyOxNMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsxCGuwPK7LJMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93ecwzsrph3YMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexacQnSNR2IuMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivities1ugNeZavwCMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDataXeikuNgoxwMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsP5HvNh241YMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93o5fhQAWFOCMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as indexz4b5C7atthMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataS5KzpaW7w2Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDataJOUXzNnJ4mMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93TmKdVEHoIjMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as index7ksMoPXm5RMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDatackwZaWf4YkMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93FucbKxrgycMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as index2PGY3CGpP5Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroupsA7FR91Jq3HMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatasq4RfrWzLSMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93DGKgWohkhkMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexrMnZZuNzcGMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesNN4oggDaJgMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesRUvSCRnJlRMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsioloXDL10iMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataZictdyMeDgMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconiasSbb6DblG9GMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesoDaV8laTjLMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93suf8iy6yD2Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexwLismbCPPgMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionswZaTMTHGU8Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltMwgcIPWeGaMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDatae9tipDQXzjMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsU195pawZsaMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93X85mfBlcniMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as index0rAe2eUKFOMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as paymentsBVqSaTFBSXMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments.vue?macro=true";
import { default as processActivitieshEaMy8G8kuMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDataQ9MAJnwZZrMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93kKmmNesggnMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id].vue?macro=true";
import { default as index3oW0ELN99CMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalVbYnfIrzsLMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93OzAlbW0jf1Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexk4tlf4GKH4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersEqX6pJ8w3UMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiesjXoGOaCgs7Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsg5R4dxtokzMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataqBen1Jxu8QMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriese0syLlxCG6Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptBtEDilhtt9Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementqJ0mMaari5Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersnsd2v5vj56Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93VLHQ04EoUAMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexniBU2eIDbGMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsCDL1Fa7ZMOMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivities5qCkqvkcQvMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData27FNjGsmI6Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFilters0Z7Wh5rGEzMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignaturen7H6Q6LRtdMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93JWePWsib8gMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexl91zcX9V7OMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersdTIdFW1ROKMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users.vue?macro=true";
import { default as settings1xflc8AUPZMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivitiesUnr7t1mD1GMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseData5VXFpikla0Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_935f52AOoOXRMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexF9AEkQCnFfMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as service4cGUwpAz7PMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service.vue?macro=true";
import { default as language1QNB1uLa0oMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatappHKgwUiirMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriest9buV8z3InMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementWlsjPUKkEtMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersjd9JZMBP6vMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93ExKrCiz9MvMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataamBtRk1zGsMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureJOjdCth3dqMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93wiwT9qXBJyMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id].vue?macro=true";
import { default as indexjAcquQuEmcMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/index.vue?macro=true";
import { default as settingsNcmXz6cchKMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings.vue?macro=true";
import { default as signatureGPmBcTd8jkMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/signature.vue?macro=true";
import { default as sportbizzY0KMON0aciMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93w2TCn7KLD9Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_935JCidbZC6wMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexm4NYBwithZMeta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93qMk4WiUap4Meta } from "/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93f6ypb1Tz3kMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexXJ4Sw2aKczMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexd9GaP2GMz4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93CkFdoLRH4YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93ZHtmpDFmrFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93X9Z6cUoZclMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsnCHqR2lgzvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexQhDp8j3YOHMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: service4cGUwpAz7PMeta?.name,
    path: "/service",
    meta: service4cGUwpAz7PMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDatackwZaWf4YkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexMURRWptuzAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93Xrc2QVbF7vMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexYHlJoNny8cMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93CoLCnKn8ENMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index9sPDoGuuG4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93Y23UiNixXUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: index4WYHgrNQ4HMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93EIsG3I1UiYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexU1J2zMNiUUMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93MvNuRQkdWvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexWV2o2ZR97FMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93IsS3mG5NKsMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexN836pZ7DspMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93ecwzsrph3YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexacQnSNR2IuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93o5fhQAWFOCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsP5HvNh241YMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: indexz4b5C7atthMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93TmKdVEHoIjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: index7ksMoPXm5RMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93FucbKxrgycMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesNN4oggDaJgMeta?.name,
    path: "parishes",
    meta: parishesNN4oggDaJgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93DGKgWohkhkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionswZaTMTHGU8Meta?.name,
    path: "regions",
    meta: regionswZaTMTHGU8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93suf8iy6yD2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: paymentsBVqSaTFBSXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93X85mfBlcniMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: index0rAe2eUKFOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93kKmmNesggnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: index3oW0ELN99CMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalVbYnfIrzsLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settings1xflc8AUPZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersEqX6pJ8w3UMeta?.name,
    path: "loginProviders",
    meta: loginProvidersEqX6pJ8w3UMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93OzAlbW0jf1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexk4tlf4GKH4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsCDL1Fa7ZMOMeta?.name,
    path: "organisations",
    meta: organisationsCDL1Fa7ZMOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93VLHQ04EoUAMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexniBU2eIDbGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersdTIdFW1ROKMeta?.name,
    path: "users",
    meta: usersdTIdFW1ROKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93JWePWsib8gMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexl91zcX9V7OMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_935f52AOoOXRMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexF9AEkQCnFfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsNcmXz6cchKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93ExKrCiz9MvMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93wiwT9qXBJyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexjAcquQuEmcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureGPmBcTd8jkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzY0KMON0aciMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93w2TCn7KLD9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_935JCidbZC6wMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexm4NYBwithZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93qMk4WiUap4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250617065210/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]